var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "step1",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var invalid = ref.invalid
          return [
            _c(
              "b-form",
              {
                ref: "productForm",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.formSubmitted($event)
                  },
                  change: function ($event) {
                    return _vm.formChanged()
                  },
                },
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Product Name",
                              "label-for": "mc-Product-name",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                rules: "required",
                                name: "Product Name",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "mc-Product-name",
                                            placeholder: "Product Name",
                                          },
                                          model: {
                                            value: _vm.Product.name,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.Product, "name", $$v)
                                            },
                                            expression: "Product.name",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-danger text-end",
                                              },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Product Classification",
                              "label-for": "mc-Product-name",
                            },
                          },
                          [
                            _c("b-form-select", {
                              attrs: { options: _vm.productTypes },
                              model: {
                                value: _vm.Product.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.Product, "type", $$v)
                                },
                                expression: "Product.type",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              "label-for": "mc-stock-threshold",
                              label: "Unit Of Measure",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "form-label-group" },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    id: "mc-Product-Code",
                                    placeholder: "Product Code",
                                    options: _vm.itemUomList,
                                    "value-field": "id",
                                    "text-field": "name",
                                  },
                                  on: { change: _vm.setUOM },
                                  model: {
                                    value: _vm.Product.uomid,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.Product, "uomid", $$v)
                                    },
                                    expression: "Product.uomid",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "2" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Enable Ecommerce",
                              "label-for": "mc-Product-Ecomm",
                            },
                          },
                          [
                            _c("b-form-checkbox", {
                              attrs: {
                                checked: "false",
                                name: "check-button",
                                switch: "",
                                inline: "",
                              },
                              model: {
                                value: _vm.Product.isEcomm,
                                callback: function ($$v) {
                                  _vm.$set(_vm.Product, "isEcomm", $$v)
                                },
                                expression: "Product.isEcomm",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Product Code",
                              "label-for": "mc-Product-Code",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                id: "mc-Product-Code",
                                placeholder: "Product Code",
                              },
                              model: {
                                value: _vm.Product.code,
                                callback: function ($$v) {
                                  _vm.$set(_vm.Product, "code", $$v)
                                },
                                expression: "Product.code",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Barcode",
                              "label-for": "mc-Barcode",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                id: "mc-Barcode",
                                type: "text",
                                placeholder: "Barcode",
                              },
                              model: {
                                value: _vm.Product.barcode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.Product, "barcode", $$v)
                                },
                                expression: "Product.barcode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              "label-for": "mc-stock-threshold",
                              label: "Low Stock Threshold",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "form-label-group" },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    name: "Low Stock Threshold",
                                    rules: "min_value:0",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "mc-stock",
                                                type: "text",
                                                placeholder:
                                                  "Low Stock Threshold",
                                              },
                                              model: {
                                                value: _vm.Product.lowStock,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.Product,
                                                    "lowStock",
                                                    $$v
                                                  )
                                                },
                                                expression: "Product.lowStock",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Category",
                              "label-for": "mc-Category",
                            },
                          },
                          [
                            _c("b-form-select", {
                              attrs: {
                                options: _vm.parentCategoryList,
                                "value-field": "id",
                                "text-field": "name",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.fetchCategoryDetails(
                                    _vm.Product.categoryID
                                  )
                                },
                              },
                              model: {
                                value: _vm.Product.categoryID,
                                callback: function ($$v) {
                                  _vm.$set(_vm.Product, "categoryID", $$v)
                                },
                                expression: "Product.categoryID",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              disabled: _vm.Product.categoryID != null,
                              label: "Sub Category",
                              "label-for": "mc-subCategory",
                            },
                          },
                          [
                            _c("b-form-select", {
                              attrs: {
                                options: _vm.subCategoryList,
                                "value-field": "id",
                                "text-field": "name",
                              },
                              model: {
                                value: _vm.Product.productCategorySubId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.Product,
                                    "productCategorySubId",
                                    $$v
                                  )
                                },
                                expression: "Product.productCategorySubId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Preferred Supplier",
                              "label-for": "mc-Supplier",
                            },
                          },
                          [
                            _c("b-form-select", {
                              attrs: {
                                options: _vm.supplierList,
                                "value-field": "id",
                                "text-field": "name",
                              },
                              model: {
                                value: _vm.Product.supplierId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.Product, "supplierId", $$v)
                                },
                                expression: "Product.supplierId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { staticClass: "mb-2", attrs: { cols: "12" } },
                      [
                        _c("label", { attrs: { for: "textarea-default" } }, [
                          _vm._v("Product Description"),
                        ]),
                        _c("b-form-textarea", {
                          attrs: {
                            id: "textarea-default",
                            placeholder: "Product Description",
                            rows: "5",
                          },
                          model: {
                            value: _vm.Product.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.Product, "description", $$v)
                            },
                            expression: "Product.description",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "3" } },
                      [
                        _c(
                          "label",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.focus.v-secondary",
                                modifiers: {
                                  hover: true,
                                  focus: true,
                                  "v-secondary": true,
                                },
                              },
                            ],
                            attrs: {
                              title:
                                "Note: Disabling a product means all current stock will be sent to scrap.",
                              for: "textarea-default",
                            },
                          },
                          [_vm._v("Enable/Disable Product ")]
                        ),
                        _c(
                          "b-form-checkbox",
                          {
                            attrs: {
                              checked: "true",
                              name: "check-button",
                              switch: "",
                            },
                            model: {
                              value: _vm.Product.isActive,
                              callback: function ($$v) {
                                _vm.$set(_vm.Product, "isActive", $$v)
                              },
                              expression: "Product.isActive",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.Product.isActive ? "Enabled" : "Disabled"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "9" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Upload / Edit Image" } },
                          [
                            _c("b-form-file", {
                              ref: "fileInput",
                              staticClass: "col-10",
                              attrs: {
                                id: "file-input",
                                placeholder: "Upload an image...",
                                accept: ".jpg, .jpeg, .png",
                              },
                              on: { change: _vm.onFileChange },
                            }),
                            _vm.errorMessage.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "error-message text-danger" },
                                  [_vm._v(_vm._s(_vm.errorMessage))]
                                )
                              : _vm._e(),
                            _vm.uploadedImage
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass: "mt-1 mx-2",
                                    attrs: { variant: "danger" },
                                    on: { click: _vm.clearImage },
                                  },
                                  [_vm._v("Clear Image")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm.Product.productImage || _vm.uploadedImage
                          ? _c(
                              "b-card-text",
                              { attrs: { title: "Product Image" } },
                              [
                                _vm.uploadedImage
                                  ? _c("img", {
                                      attrs: {
                                        src: _vm.uploadedImage,
                                        width: "250",
                                        height: "250",
                                      },
                                    })
                                  : _c("img", {
                                      attrs: {
                                        src:
                                          "data:image/jpeg;base64," +
                                          _vm.Product.productImage,
                                        width: "250",
                                        height: "250",
                                      },
                                    }),
                              ]
                            )
                          : _vm._e(),
                        _vm.Product.productImage && !_vm.uploadedImage
                          ? _c(
                              "b-button",
                              {
                                staticClass: "mt-1",
                                attrs: { variant: "danger" },
                                on: { click: _vm.removeExistingImage },
                              },
                              [_vm._v("Remove")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("CustomFieldsDetails", {
                  attrs: {
                    AdditionalFields: _vm.Product.additionalFields,
                    ModuleReference: "Product",
                  },
                  on: { onchange: _vm.additionalFieldChanges },
                }),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }